/* @flow */

import * as React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import zIndexScale from '../utils/zIndexScale';

const MIN_DISTANCE_TO_BOTTOM = 50;

const TooltipIcon = styled.i`
  // cursor: help;
  font-size: ${({ size }) => `${size || 15}px`};
  color: ${({ theme }) => theme.fontColor1};
  position: relative;
  z-index: ${zIndexScale.tooltip};
`;

export const TooltipContent = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.fontColor};
  position: absolute;
  ${({ isOnTop }) => isOnTop ? 'bottom: 2.8em;' : 'top: 2.8em;'}
  background: ${({ theme }) => theme.tooltipBg};
  box-shadow: ${({ theme }) => theme.boxShadow};
  padding: 16px;
  transform: translateX(-50%);
  width: 220px;
  min-width: 220px;
  word-break: break-word;
  line-height: 1.5;
  font-weight: normal;
  z-index: ${zIndexScale.tooltip};
`;

export type Props = { children?: number | string | React.Element<*> | Array<any>, iconClass: string};
export type State = { isOpen: boolean, isOnTop: boolean };

export default class extends React.PureComponent<Props, State> {
  _node = React.createRef();

  static defaultProps = {
    children: null,
    iconClass: '',
  };

  state = { isOpen: false, isOnTop: false }

  componentDidMount() {
    window.addEventListener('mousedown', this._onClickedOutside);
    window.addEventListener('touchstart', this._onClickedOutside);
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this._onClickedOutside);
    window.removeEventListener('touchstart', this._onClickedOutside);
  }

  _onClickedOutside = (ev: MouseEvent) => {
    if (!this.state.isOpen || !this._node) return;
    if (this._node.current &&
        this._node.current.parentElement.contains(ev.target)) {
      return;
    }
    this.setState({ isOpen: false });
  }

  _onClickedInner = (ev: MouseEvent) => {
    ev.stopPropagation();
    this.setState({ isOpen: false });
  }

  _toggleTooltip = (ev: MouseEvent) => {
    ev.stopPropagation();
    if (!ev || !ev.target) return;
    if (!(ev.target instanceof HTMLElement)) return;
    const distance =
      window.innerHeight - ev.target.getBoundingClientRect().top;
    this.setState({
      isOpen: !this.state.isOpen,
      isOnTop: distance < MIN_DISTANCE_TO_BOTTOM,
    });
  }

  render() {
    const { children, iconClass } = this.props;
    const { isOpen, isOnTop } = this.state;
    return (
      <React.Fragment>
        <TooltipIcon
          className={iconClass ? `iconfont icon-${iconClass}` : 'iconfont icon-wen toolTip'}
          onClick={this._toggleTooltip}
          ref={this._node}
        />
        <CSSTransitionGroup
          transitionName="tooltip"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          {isOpen ? (
            <TooltipContent isOnTop={isOnTop} onClick={this._onClickedInner}>
              {children}
            </TooltipContent>
          ) : null }
        </CSSTransitionGroup>
      </React.Fragment>
    );
  }
}
